<template>
<div class="chapter">
<div class="inner_page">
<img src="04-chapter03.html.jpg" style="margin-right: 0px;"/>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04-chapter03.vue?8fe21310